import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';


const NavigationBar = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeBucket, setActiveBucket] = useState('production-assets');

  const isActive = (path) => location?.pathname === path;

  const handleBucketClick = () => {
    console.log('Bucket selector clicked');
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <button
        className="nav-bar-menu-toggle"
        onClick={toggleMobileMenu}
        aria-label="Toggle menu">

        <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={20} />
      </button>

      <nav className="nav-bar bg-gradient-to-r from-[rgba(30,60,110,1)] to-[rgba(187, 211, 246, 1)]">
        <div className="nav-bar-logo">
          <img
            src="/assets/images/emz_logo-1766196683284.png"
            alt="EMZ DROP logo with stylized EMZ letters in navy blue"
            className="nav-bar-logo-image"
            style={{ height: '32px', width: 'auto' }} />

          <span className="nav-bar-logo-text text-[rgba(244,245,246,1)]">EMZ DROP</span>
        </div>

        <div className="nav-bar-links">
          <Link
            to="/file-browser"
            className={`nav-bar-link ${isActive('/file-browser') ? 'nav-bar-link-active' : ''}`}>

            <Icon name="FolderOpen" size={16} className="inline mr-2" />
            File Browser
          </Link>
          <Link
            to="/settings"
            className={`nav-bar-link ${isActive('/settings') ? 'nav-bar-link-active' : ''}`}>

            <Icon name="Settings" size={16} className="inline mr-2" />
            Settings
          </Link>
        </div>

        




      </nav>

      {isMobileMenuOpen &&
      <>
          <div
          className="mobile-menu-overlay animate-fade-in"
          onClick={closeMobileMenu} />

          <div className="mobile-menu animate-slide-in-left">
            <div className="mobile-menu-header">
              <div className="flex items-center gap-3">
                <img
                src="/assets/images/emz_logo-1766196683284.png"
                alt="EMZ DROP logo with stylized EMZ letters in navy blue"
                style={{ height: '24px', width: 'auto' }} />

                <span className="text-lg font-semibold">EMZ DROP</span>
              </div>
              <button onClick={closeMobileMenu} aria-label="Close menu">
                <Icon name="X" size={20} />
              </button>
            </div>

            <div className="mobile-menu-links">
              <Link
              to="/file-browser"
              className={`mobile-menu-link ${isActive('/file-browser') ? 'mobile-menu-link-active' : ''}`}
              onClick={closeMobileMenu}>

                <Icon name="FolderOpen" size={16} className="inline mr-3" />
                File Browser
              </Link>
              <Link
              to="/settings"
              className={`mobile-menu-link ${isActive('/settings') ? 'mobile-menu-link-active' : ''}`}
              onClick={closeMobileMenu}>

                <Icon name="Settings" size={16} className="inline mr-3" />
                Settings
              </Link>
            </div>

            <div className="p-4 mt-auto border-t border-border">
              <div className="nav-bar-bucket-indicator w-full justify-between" onClick={handleBucketClick}>
                <div className="flex items-center gap-2">
                  <Icon name="Database" size={14} />
                  <span>{activeBucket}</span>
                </div>
                <Icon name="ChevronDown" size={14} />
              </div>
            </div>
          </div>
        </>
      }
    </>);

};

export default NavigationBar;